/**
 * App — providers + router. Kept thin: the QueryClientProvider wraps the whole
 * tree so hooks share one cache, and RouterProvider drives the real routes.
 */
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { queryClient } from "@/lib/queryClient";
import { router } from "@/router";

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
